import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative lg:min-h-screen bg-cover bg-center bg-no-repeat bg-other-hero">
      <div className="relative container px-3 py-10 flex flex-col justify-center items-center gap-[24px] text-white text-center lg:min-h-[90dvh] ">
        <h1 className="text-[24px] lg:text-[40px] font-bold">
          Data Annotation
        </h1>
        <p className="text-lg md:text-xl max-w-[753px] mx-auto text-center">
          Our expert annotation team converts your images and videos into
          high-quality labeled datasets that power accurate computer vision
          models.
        </p>
        <Link
          className="border border-primary_alt bg-white px-4 py-2.5 rounded-lg h-max block text-primary_alt font-medium"
          to="/signup"
        >
          Get Your Data Annotated
        </Link>
      </div>
    </section>
  );
};

export default Hero;
